// import { useRequest } from 'ahooks';
import { useModel } from '@umijs/max';
import { useRequest } from 'ahooks';
import { omit } from 'lodash';
import { useState } from 'react';
import memberCommon from '../memberCommon';
import {
  addBmMemberService,
  batchActivationService,
  batchBuyVasService,
  batchChangeLanguageService,
  batchMigrateDepartmentSubmitService,
  batchReactiveService,
  batchSimLostService,
  batchSimReplacementQueryCardTypeService,
  batchSimReplacementQuerySkuService,
  batchSimReplacementSubmitService,
  batchSimRestoreService,
  batchSuspendService,
  changeBundleMemberOfferService,
  changeCommentsService,
  changeOfferService,
  changeSimCardService,
  changeVasSubmit,
  checkMisidnService,
  deleteBmMemberService,
  exportMemberService,
  getSysparam,
  modifyBillService,
  newConnectionService,
  numberShiftingService,
  orderVas,
  qrySubsEventServTypeService,
  queryBusinessFeeService,
  queryChangeOffersService,
  queryMemberResource,
  queryModifyOfferService,
  queryNumberGradeService,
  queryOfferService,
  querySuspendReasonService,
  simReplacementService,
} from '../services';

export default function MemberMgrModel() {
  const { initialState } = useModel('@@initialState');
  const { bcareUserId } = initialState || {};
  const [selectedAccount, setSelectedAccount] = useState<any>(null); // 左侧选中账户
  const [selectedRows, setSelectedRows] = useState<any[]>([]); // 选择成员列表
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState<boolean>(true); // 二次业务提交按钮状态
  const [selectedBtnKey, setSelectedBtnKey] = useState<any>(null); // 二次业务点击的事件
  const [currentOffer, setCurrentOffer] = useState({}); // 选中的订户套餐
  const [showPaymentBtn, setShowPaymentBtn] = useState<boolean>(false); // 是否显示付款按钮
  const [paymentCounterShow, setPaymentCounterShow] = useState<any>(null); // 展示付费弹框
  const [batchUploadData, setBatchUploadData] = useState<any>(null); // 批量买包上传数据
  const { useCustomModel } = memberCommon;
  const customModal: any = useCustomModel();
  const customServiceLoading = customModal?.customEventLoading || false;

  const {
    data,
    run: queryResources,
    loading: detailLoading,
    refresh,
    mutate: resetInfo,
  } = useRequest(queryMemberResource, {
    manual: true,
  });

  const { data: defaultExpDate, run: getdefaultExpDate } = useRequest(
    getSysparam,
    {
      manual: true,
    },
  );

  const { data: umServType, run: getServType } = useRequest(
    () => getSysparam({ mask: 'UM_MEMB_SERV_TYPE' }),
    {
      manual: true,
    },
  );

  const { data: commonServType, run: getCommonServType } = useRequest(
    () => getSysparam({ mask: 'BCARE_MEMBER_SERV_TYPE' }),
    {
      manual: true,
    },
  );

  const { data: isneedNewConnect, run: getIsNeedNewConnecton } = useRequest(
    () => getSysparam({ mask: 'IS_ALLOWED_NEW_CONNECTION' }),
    {
      manual: true,
    },
  );

  const { data: subsEvents, runAsync: queryEvents } = useRequest(
    qrySubsEventServTypeService,
    {
      manual: true,
    },
  );

  const unsubscribe = async (record: any, offerItem: any) => {
    const params = {
      subsId: record.subsId,
      prefix: record.prefix,
      accNbr: record.msisdn,
      partyCode: bcareUserId.toString(),
      partyType: 'Y',
      vass: [
        {
          offerId: offerItem.offerId,
          effType: 'B', // B立即生效
          operationType: 'D', // A表示取消
        },
      ],
    };
    if (record.servType === 15) {
      await orderVas({
        ...params,
        vass: [
          {
            offerId: offerItem.offerId,
            effType: 'B', // B立即生效
            operationType: 'D', // A表示取消
          },
        ],
      });
      refresh();
    } else {
      await changeVasSubmit({
        ...params,
        contactChannelId: 18,
        vasList: [
          {
            offerId: offerItem.offerId,
            offerCode: offerItem.offerCode,
            operationType: 'D', // A表示取消
          },
        ],
      });
      refresh();
    }
  };

  const { loading: exportMemberLoading, runAsync: exportMember } = useRequest(
    exportMemberService,
    {
      manual: true,
    },
  );

  // 二次业务相关
  const { loading: addMemberLoading, runAsync: addBmMember } = useRequest(
    addBmMemberService,
    {
      manual: true,
    },
  );

  const {
    data: offerData,
    run: queryOffers,
    loading: buyOfferQueryLoading,
    mutate: mutateOfferData,
  } = useRequest(
    (params: any) =>
      params?.modal
        ? queryChangeOffersService(omit(params, ['modal']))
        : queryOfferService(params),
    {
      manual: true,
    },
  );

  const { loading: orderVasLoading, runAsync: buyOfferOrderVas } = useRequest(
    orderVas,
    {
      manual: true,
    },
  );

  const { loading: batchChangeLoading, runAsync: changeLanguage } = useRequest(
    batchChangeLanguageService,
    {
      manual: true,
    },
  );

  const { loading: numberShiftingLoading, runAsync: numberShifting } =
    useRequest(numberShiftingService, {
      manual: true,
    });

  const { loading: deleteBmMemberLoading, runAsync: deleteBmMember } =
    useRequest(deleteBmMemberService, {
      manual: true,
    });

  const { loading: modifyBillLoading, runAsync: modifyBill } = useRequest(
    modifyBillService,
    {
      manual: true,
    },
  );

  const { loading: changeOfferLoading, runAsync: changeOffer } = useRequest(
    changeOfferService,
    {
      manual: true,
    },
  );

  const {
    loading: changeBundleMemberOfferLoading,
    runAsync: changeBundleMemberOffer,
  } = useRequest(changeBundleMemberOfferService, {
    manual: true,
  });

  const { data: reasonData, run: queryReasons } = useRequest(
    querySuspendReasonService,
    {
      manual: true,
    },
  );

  const { loading: reactiveLoading, runAsync: reactive } = useRequest(
    batchReactiveService,
    {
      manual: true,
    },
  );

  const { loading: suspendLoading, runAsync: suspend } = useRequest(
    batchSuspendService,
    {
      manual: true,
    },
  );

  const { loading: feeLoading, runAsync: queryBusinessFee } = useRequest(
    queryBusinessFeeService,
    {
      manual: true,
    },
  );

  const { data: gradeData = {}, run: queryGrade } = useRequest(
    queryNumberGradeService,
    {
      manual: true,
    },
  );

  const { loading: checkMisidnLoading, runAsync: checkMisidn } = useRequest(
    checkMisidnService,
    {
      manual: true,
    },
  );

  const { loading: changeCardLoading, runAsync: changeSimCard } = useRequest(
    changeSimCardService,
    {
      manual: true,
    },
  );

  const { loading: batchOrderVasLoading, runAsync: batchBuyOfferOrderVas } =
    useRequest(batchBuyVasService, {
      manual: true,
    });

  const { loading: newConnectionLoading, runAsync: newConnection } = useRequest(
    newConnectionService,
    {
      manual: true,
    },
  );

  const { loading: changeCommentsLoading, runAsync: changeComments } =
    useRequest(changeCommentsService, {
      manual: true,
    });

  const { data: offerDetailSystem, run: getOfferDetailSystem } = useRequest(
    () => getSysparam({ mask: 'BCARE_OFFER_DETAIL_ENABLE' }),
    {
      manual: true,
    },
  );

  const { data: offerAgreementSystem, run: getAgreementSystem } = useRequest(
    () => getSysparam({ mask: 'BCARE_ENABLE_CHANGE_OFFER_WITH_AGREEMENT' }),
    {
      manual: true,
    },
  );

  const { data: offerGradeSystem, run: getOfferGradeSystem } = useRequest(
    () => getSysparam({ mask: 'BCARE_OFFER_GRADE' }),
    {
      manual: true,
    },
  );

  const { data: agreementServiceType, run: getAgreementServType } = useRequest(
    () => getSysparam({ mask: 'BCARE_BUNDLE_AGREEMENT_SERV_TYPE' }),
    {
      manual: true,
    },
  );

  const { data: isFixedServType, run: getFixedServTypeSystem } = useRequest(
    () => getSysparam({ mask: 'BCARE_FIXED_SERV_TYPE' }),
    {
      manual: true,
    },
  );

  const { data: digitalSolutionSystem, run: getDigitalSolutionSystem } =
    useRequest(() => getSysparam({ mask: 'BCARE_DIGITAL_SOLUTION_LINK' }), {
      manual: true,
    });

  const { runAsync: getSlotOffsetSystem } = useRequest(
    () => getSysparam({ mask: 'BCARE_QUERY_SLOT_OFFSET' }),
    {
      manual: true,
    },
  );

  const { data: createDemandCaseUrlSystem, run: getCreateDemandCaseUrlSystem } =
    useRequest(() => getSysparam({ mask: 'BCARE_CREATE_DEMAND_CASE_URL' }), {
      manual: true,
    });
  const {
    data: createDemandCaseErrorUrlSystem,
    run: getCreateDemandCaseErrorUrlSystem,
  } = useRequest(
    () => getSysparam({ mask: 'BCARE_CREATE_DEMAND_CASE_ERROR_URL' }),
    {
      manual: true,
    },
  );
  const {
    data: createDemandCaseErrorMsgSystem,
    run: getCreateDemandCaseErrorMsgSystem,
  } = useRequest(
    () => getSysparam({ mask: 'BCARE_CREATE_DEMAND_CASE_ERROR_MSG' }),
    {
      manual: true,
    },
  );

  const { data: systemChangeBundleOffer, run: getSystemChangeBundleOffer } =
    useRequest(
      () =>
        getSysparam({
          mask: 'BCARE_CHANGE_OFFER_DISABLE_IDS',
        }),
      {
        manual: true,
      },
    );

  const {
    mutate: mutateBunldeModifyData,
    loading: bundleModifyOfferLoading,
    data: bundleOffers = [],
    runAsync: queryBundleOffers,
  } = useRequest(queryModifyOfferService, { manual: true });

  const {
    data: allBundleMemberServTypeSystem,
    run: getAllBundleMemberServTypeSystem,
  } = useRequest(
    () => getSysparam({ mask: 'BCARE_ALL_BUNDLE_MEMBER_SERV_TYPE' }),
    {
      manual: true,
    },
  );

  const { loading: simReplacementLoading, runAsync: simReplacement } =
    useRequest(simReplacementService, {
      manual: true,
    });

  const { runAsync: batchActivation, loading: batchActivationLoading } =
    useRequest(batchActivationService, { manual: true });

  const {
    loading: batchSimReplacementCardTypeLoading,
    data: batchSimReplacementCardTypeData,
    runAsync: queryBatchSimReplacementCardType,
  } = useRequest(batchSimReplacementQueryCardTypeService, {
    manual: true,
  });

  const { data: batchSimReplacementSkuData, run: querybatchSimReplacementSku } =
    useRequest(batchSimReplacementQuerySkuService, {
      manual: true,
    });

  const {
    loading: batchSimReplacementSubmitLoading,
    runAsync: batchSimReplacementSubmit,
  } = useRequest(batchSimReplacementSubmitService, {
    manual: true,
  });

  const { loading: batchSimLostLoading, runAsync: batchSimLost } = useRequest(
    batchSimLostService,
    { manual: true },
  );

  const { loading: batchSimRestoreLoading, runAsync: batchSimRestore } =
    useRequest(batchSimRestoreService, { manual: true });

  const {
    loading: batchMigrateDepartmentLoading,
    runAsync: batchMigrateDepartment,
  } = useRequest(batchMigrateDepartmentSubmitService, { manual: true });

  return {
    selectedAccount,
    setSelectedAccount,
    queryResources,
    detailLoading,
    basicInfo: data || {},
    resourceData: data?.resource,
    balanceList: data?.balShareList || [],
    serviceList: data?.serviceList || [],
    agreementInstList: [
      ...(data?.agreementInstList || []),
      ...(data?.contractItemSubsList || []),
    ],
    resetInfo,
    defaultExpDate,
    getdefaultExpDate,
    unsubscribe,
    queryEvents,
    subsEvents,
    selectedRows,
    setSelectedRows,
    exportMemberLoading,
    exportMember,
    selectedBtnKey,
    setSelectedBtnKey,
    umServType,
    getServType,
    showPaymentBtn,
    setShowPaymentBtn,
    paymentCounterShow,
    setPaymentCounterShow,
    // 二次业务相关state
    submitBtnDisabled,
    setSubmitBtnDisabled,
    batchUploadData,
    setBatchUploadData,
    loading:
      addMemberLoading ||
      orderVasLoading ||
      batchChangeLoading ||
      numberShiftingLoading ||
      deleteBmMemberLoading ||
      modifyBillLoading ||
      changeOfferLoading ||
      reactiveLoading ||
      suspendLoading ||
      feeLoading ||
      changeCardLoading ||
      batchOrderVasLoading ||
      newConnectionLoading ||
      changeCommentsLoading ||
      changeBundleMemberOfferLoading ||
      customServiceLoading ||
      simReplacementLoading ||
      batchActivationLoading ||
      batchSimReplacementSubmitLoading ||
      batchSimLostLoading ||
      batchSimRestoreLoading ||
      batchMigrateDepartmentLoading,
    addBmMember,
    offerList:
      offerData?.productOffering || offerData?.offerList || bundleOffers || [],
    queryOffers,
    buyOfferQueryLoading: bundleModifyOfferLoading || buyOfferQueryLoading,
    buyOfferOrderVas,
    changeLanguage,
    numberShifting,
    deleteBmMember,
    modifyBill,
    queryBusinessFee,
    changeOffer,
    changeBundleMemberOffer,
    queryReasons,
    reasonList: reasonData?.orderReasons || [],
    reactive,
    suspend,
    gradeList: gradeData.accNbrClassList || [],
    queryGrade,
    changeSimCard,
    checkMisidnLoading,
    checkMisidn,
    commonServType,
    getCommonServType,
    batchBuyOfferOrderVas,
    newConnection,
    changeComments,
    isneedNewConnect,
    getIsNeedNewConnecton,
    currentOffer,
    setCurrentOffer,
    offerDetailSystem,
    getOfferDetailSystem,
    offerAgreementSystem: offerAgreementSystem || 'N',
    getAgreementSystem,
    offerGradeSystem,
    getOfferGradeSystem,
    agreementServiceType,
    getAgreementServType,
    queryBundleOffers,
    mutateOfferData,
    mutateBunldeModifyData,
    isFixedServType,
    getFixedServTypeSystem,
    digitalSolutionSystem,
    getDigitalSolutionSystem,
    getSlotOffsetSystem,
    createDemandCaseUrlSystem,
    getCreateDemandCaseUrlSystem,
    createDemandCaseErrorUrlSystem,
    getCreateDemandCaseErrorUrlSystem,
    createDemandCaseErrorMsgSystem,
    getCreateDemandCaseErrorMsgSystem,
    systemChangeBundleOffer,
    getSystemChangeBundleOffer,
    getAllBundleMemberServTypeSystem,
    allBundleMemberServTypeSystem,
    simReplacement,
    batchActivation,
    queryBatchSimReplacementCardType,
    batchSimReplacementCardTypeData,
    batchSimReplacementCardTypeLoading,
    querybatchSimReplacementSku,
    batchSimReplacementSkuData,
    batchSimReplacementSubmit,
    batchSimLost,
    batchSimRestore,
    batchMigrateDepartment,
    ...customModal,
    ...useCustomModel,
  };
}
